import { useQuery } from "@tanstack/react-query";
import { BriefConfigService } from "../../services/briefConfigService";
import {
  BRIEF_FACETS_QUERY_KEY,
  BRIEF_INFLUENCER_CONFIG_FACETS_QUERY_KEY,
  BRIEF_TASK_FORMS,
} from "../../constants";
import { useEffect } from "react";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBRIEF_CONFIG_FACET } from "@shared/lib/types/brief";
import { IGetBriefConfigDeliverableFacetValueResponse } from "@shared/lib/types/briefConfig";
import {
  IGetTaskFormRequest,
  IGetTaskFormResponse,
} from "@shared/lib/types/briefCampains";

export function useGetBriefTaskForms(params: IGetTaskFormRequest) {
  const { briefId, ...rest } = params;
  const { data, isError, isLoading, error } = useQuery<
    BackednResponse<IGetTaskFormResponse>
  >({
    queryKey: [...BRIEF_TASK_FORMS(briefId), rest],
    queryFn: () => BriefConfigService.getTaskForm(params),
  });

  const errorMessage = isError && error?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    forms: data?.data,
    isFetching: isLoading,
  };
}
